export default function restoreCart(cart) {
  return fetch(`${window.routes.cart_clear_url}.js`).then(() => {
    if (!cart?.items.length) {
      return cart;
    }

    const data = {
      items: cart.items.toReversed().map(({ properties, quantity, id, selling_plan_allocation }) => {
        const item = {
          quantity,
          id,
        };

        if (properties) {
          item.properties = properties;
        }

        if (selling_plan_allocation) {
          item.selling_plan = selling_plan_allocation.selling_plan.id;
        }

        return item;
      })
    };

    return fetch(`${window.routes.cart_add_url}.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    }).then(res => res.json());
  })
}
;
